import { ThemeProvider } from 'next-themes';

type Properties = {
  children: React.ReactNode;
};

export function AppThemeProvider({ children }: Properties) {
  return (
    <ThemeProvider defaultTheme="light" attribute="class">
      {children}
    </ThemeProvider>
  );
}
